import React from "react";
import { useSelector } from "react-redux";
import { useTheme } from "../../hooks/useTheme";
import { ItemCardVariant } from "../../types/enums";
import { useItemRelations } from "./useItemRelations";
import { SaleItemInterface } from "../../types/types";
import styles from "./ItemRelations.module.scss";
import { selectCurrentCluster } from "../../../store/slices/currentClusterSlice";
import { AddonItem } from "../../../pages/main/components/addonItem/AddonItem";
import Item from "../../../pages/main/components/item/Item";

interface ItemRelationsProps {
  addons?: Array<{ addon: SaleItemInterface }>;
  recommendations?: Array<{ recommended: SaleItemInterface }> | null;
  getCategoryName: (id: number) => string | undefined;
  variant?: "item" | "group";
}

export const ItemRelations = ({
  addons,
  recommendations,
  getCategoryName,
  variant = "item",
}: ItemRelationsProps) => {
  const { theme } = useTheme();
  const currentCluster = useSelector(selectCurrentCluster);

  const {
    addonItems,
    recommendationItems,
    hasAddons,
    hasRecommendations,
    getItemQuantity,
    handleAddToCart,
    handleIncrease,
    handleDecrease,
    handleRemove,
  } = useItemRelations({
    addons,
    recommendations,
  });

  if (!hasAddons && !hasRecommendations) return null;

  return (
    <div className={styles.container}>
      {/* Аддоны */}
      {hasAddons && (
        <>
          <h3 className={styles.sectionTitle} style={{ color: theme.text }}>
            Добавить к заказу
          </h3>
          <div className={styles.addonsContainer}>
            {addonItems.map((addon) => (
              <AddonItem
                key={addon.id}
                item={addon}
                quantity={getItemQuantity(addon.id)}
                onAdd={() => handleAddToCart(addon)}
                onIncrease={() => handleIncrease(addon.id)}
                onDecrease={() => handleDecrease(addon.id)}
                onRemove={() => handleRemove(addon.id)}
              />
            ))}
          </div>
        </>
      )}

      {/* Рекомендации */}
      {hasRecommendations && (
        <>
          <h3 className={styles.sectionTitle} style={{ color: theme.text }}>
            С этим товаром покупают
          </h3>
          <div className={styles.recommendationsContainer}>
            <div className={styles.scrollContent}>
              {recommendationItems.map((rec) => (
                <Item
                  key={rec.id}
                  item={rec}
                  getCategoryName={getCategoryName}
                  variant={ItemCardVariant.RECOMMENDATION}
                  horizontal
                />
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};
